import { TextAlignment, VerticalAlignment } from '../../../../../../common/table/CellTypeConstants';
import { getAllCellsBetween } from '../../selectionUtils/tableSelectionGeometryUtils';
import { createTableCellEntry } from '../../../../../../common/table/utils/tableInitialisationUtils';
import { getCellTextAlignment } from '../../dataUtils/cell/tableCellDisplayUtils';
import { TABLE_CELL_DEFAULT_VERTICAL_ALIGNMENT } from '../../../../../../common/table/tableConstants';
import { MNHotInstance } from '../../../tableHotInstanceTypes';

/**
 * Determines if the provided text alignment is applied to all selected cells.
 */
export const isHotTableTextAlignmentApplied = (
    hotInstance: MNHotInstance,
    textAlignment: TextAlignment,
    locale: string,
    cellSelections = hotInstance.getSelected(),
): boolean => {
    if (!cellSelections) return false;

    return !getAllCellsBetween(cellSelections).some(({ row, col }) => {
        const { cellData = createTableCellEntry() } = hotInstance.getCellMeta(row, col);
        const hotComputedCellValue = hotInstance.getDataAtCell(row, col); // For formulas, will return formula result

        return getCellTextAlignment(cellData, locale, hotComputedCellValue) !== textAlignment;
    });
};

/**
 * Determines if the provided vertical alignment is applied to all selected cells.
 */
export const isHotTableVerticalAlignmentApplied = (
    hotInstance: MNHotInstance,
    verticalAlignment: VerticalAlignment,
    cellSelections = hotInstance?.getSelected(),
): boolean => {
    if (!cellSelections) return false;

    return !getAllCellsBetween(cellSelections).some(({ row, col }) => {
        const { cellData = createTableCellEntry() } = hotInstance.getCellMeta(row, col);

        if (!cellData.verticalAlignment) return verticalAlignment !== TABLE_CELL_DEFAULT_VERTICAL_ALIGNMENT;

        return cellData.verticalAlignment !== verticalAlignment;
    });
};
